import { GET_LIVESTOCK_SALE_DATA_CHANGES } from "constants/actionTypes";

export const fetchLivestockSaleDataChanges = (sale, saleyard) => ({
  type: GET_LIVESTOCK_SALE_DATA_CHANGES,
  sale,
  saleyard,
});
